import { makeAutoObservable } from 'mobx'
import { v4 as uuid } from 'uuid'

import { ChatHistoryOpenedFromInfo, FeedBackModalConfig } from '../../types'
import { ChatConfigUIStateEnum } from '../../constants'

class AIChatUIStore {
   private _activeUIStateEnum!: ChatConfigUIStateEnum
   private _feedBackModalConfig!: FeedBackModalConfig | null
   private _chatHistoryOpenedFromInfo!: ChatHistoryOpenedFromInfo | null
   private _refreshId!: string | null

   private constructor() {
      this.init()

      makeAutoObservable(this, {}, { autoBind: true })
   }

   private init(): void {
      this._activeUIStateEnum = ChatConfigUIStateEnum.ChatState
      this._feedBackModalConfig = null
      this._refreshId = null
      this._chatHistoryOpenedFromInfo = null
   }

   // #region - Active UI State

   get activeUIStateEnum(): ChatConfigUIStateEnum {
      return this._activeUIStateEnum
   }

   setActiveUIStateEnum = (uiStateEnum: ChatConfigUIStateEnum): void => {
      this._activeUIStateEnum = uiStateEnum
   }
   // #engregion

   // #region - FeedBack Modal

   get feedBackModalConfig(): FeedBackModalConfig | null {
      return this._feedBackModalConfig
   }

   openFeedBackModal = (
      config: Omit<FeedBackModalConfig, 'isModalOpen'>
   ): void => {
      this._feedBackModalConfig = {
         isModalOpen: true,
         ...config
      }
   }

   closeFeedBackModal = (): void => {
      this._feedBackModalConfig = this._feedBackModalConfig
         ? {
              ...this._feedBackModalConfig,
              isModalOpen: false
           }
         : null
   }
   // #endregion

   // #region - Refresh Id

   get refreshId(): string | null {
      return this._refreshId
   }

   setRefreshId = (): void => {
      this._refreshId = uuid()
   }
   // #endregion

   // #region - Chat History

   get chatHistoryOpenedFromInfo(): ChatHistoryOpenedFromInfo | null {
      return this._chatHistoryOpenedFromInfo
   }

   setChatHistoryOpenedFromInfo = (
      info: ChatHistoryOpenedFromInfo | null
   ): void => {
      this._chatHistoryOpenedFromInfo = info
   }
   // #endregion

   clearStore = (): void => {
      this.init()
   }

   static createStore = (): AIChatUIStore => new AIChatUIStore()
}

export default AIChatUIStore
